import React from 'react'

// icons
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'
import useDelete from './hooks/useDelete'

const ItemArticuloEliminado = ({ articulo, setIsLoad }) => {
    const { recoverArticuloSubmit } = useDelete(setIsLoad)

    return (
        <tr>
            <th scope="row">{articulo.codigo}</th>
            <td>{articulo.nombre}</td>
            <td>{articulo.pesable ? 'SI' : 'NO'}</td>
            <td>{articulo.balanza ? 'SI' : 'NO'}</td>
            <td>{articulo.compuesto ? 'SI' : 'NO'}</td>
            <td>${articulo.costo.toFixed(2)}</td>
            <td>${articulo.precioFinal.toFixed(2)}</td>
            <td>{articulo.porcentajeGanancia}%</td>
            <td>{articulo.familia.nombre}</td>
            <td>{articulo.marca.nombre}</td>
            <td>{articulo.unidadMedida.nombre}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverArticuloSubmit(articulo)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemArticuloEliminado)
